<template>
<div class="panelNagusia">
  <h1 class="ui header"><img class="ui image" src="../../assets/parcels.png">
    <div class="content">Pedidos</div>
  </h1>
  <div class="ui stackable ">
    <div class="row">
      <h4 class="ui dividing header">Buscar</h4>
      <form class="ui form" @submit.prevent="searchParcel">
        <div class="three fields">
          <div class="field">
            <sui-input placeholder="Referencia" icon="shopping basket" v-model="search.name" />
          </div>
          <div class="field">
            <sui-input placeholder="Teléfono" icon="phone" v-model="search.phone" />
          </div>
          <div class="field">
            <sui-dropdown fluid multiple :options="statusOptions" placeholder="Estado" selection v-model="search.status" />
          </div>
        </div>
        <div class="three fields">
          <div class="field">
            <sui-input onfocus="(this.type='date')"  onblur="(this.type='text')" icon='calendar' placeholder="Fecha Inicio" v-model="search.startDate" />
          </div>
          <div class="field">
            <sui-input onfocus="(this.type='date')"  onblur="(this.type='text')" icon='calendar' placeholder="Fecha Fin" v-model="search.startEnd" />
          </div>
          <div class="field">
            <button class="ui button fluid" type="submit">Buscar</button>
          </div>
        </div>
      </form>
    </div>
    <div v-if="(searching && rows.length==0)" class="ui active centered inline loader"></div>
    <div v-if="(rows.length!=0)" class="row">
      <div class="column">
        <h4 class="ui dividing header">Los últimos movimientos</h4>
        <vue-good-table :columns="columns" :rows="rows" :lineNumbers="true" :pagination-options="{
                perPage: 50,
                enabled: true,
                mode: 'pages'
                }" :sort-options="{
                enabled: false,
                initialSortBy: {field: 'lastUpdate', type: 'desc'}
                }"
          @on-row-click="parcelInfo" styleClass="vgt-table striped condensed bordered">
          >
        </vue-good-table>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'shParcelList',
  data() {
    return {
      role: null,
      searching: null,
      statusOptions: [{
        // 'text': 'en el armario',
        'text': 'en armario',
        'value': 'in-apt'
      },
      {
        // 'text': 'recogido por cliente',
        'text': 'entregado',
        'value': 'delivered'
      },
      {
        // 'text': 'retirado por tienda',
        'text': 'retirado por comercio',
        'value': 'to-term'
      }],
      search: {
        'name': null,
        'phone': null,
        'startDate': null,
        'startEnd': null
      },
      columns: [{
          label: 'Referencia',
          field: 'name',
          filterOptions: {
            placeholder: 'Referencia',
            enabled: true, // enable filter for this column
            trigger: 'keyup', //only trigger on enter not on keyup
          }
        },
        {
          label: 'Teléfono',
          field: 'phone',
          filterOptions: {
            placeholder: 'Teléfono',
            enabled: true, // enable filter for this column
            trigger: 'keyup', //only trigger on enter not on keyup
          }
        },
        {
          label: 'Estado',
          field: 'status2',
          filterOptions: {
            placeholder: 'Estado',
            enabled: true, // enable filter for this column
            trigger: 'keyup', //only trigger on enter not on keyup
          },
          // formatFn: this.formatStatus,
        },
        {
          label: 'Nº slots',
          field: 'n_bultos',
          type: 'number',
          width: '60px'
          // filterOptions: {
          //   placeholder: 'Bultos',
          //   enabled: false, // enable filter for this column
          //   trigger: 'keyup', //only trigger on enter not on keyup
          // }
        },
        {
          label: 'Importe',
          field: 'amount',
          type: 'number',
          width: '60px',
          formatFn: this.formatAmount,
          // filterOptions: {
          //   placeholder: 'Importe',
          //   enabled: false, // enable filter for this column
          //   trigger: 'keyup', //only trigger on enter not on keyup
          // }
        },
        {
          label: 'F. Pagado',
          field: 'pay_date',
          width: '120px',
          type: 'date',
          dateInputFormat: 'YYYY-MM-DD HH:mm',
          dateOutputFormat: 'YYYY-MM-DD HH:mm',
        },
        {
          label: 'Ult. Actualización',
          field: 'lastUpdate',
          width: '120px',
          type: 'date',
          dateInputFormat: 'YYYY-MM-DD HH:mm',
          dateOutputFormat: 'YYYY-MM-DD HH:mm',
        }
      ],
      rows: [],
    }
  },
  created() {
    this.searching = false
    this.role = JSON.parse(localStorage.admin).role;
  },

  methods: {
    prueba() {
      alert('En prueba')
      console.log('En prueba')
    },
    updateTable(req) {
      // console.log(req)
      // const parcels = []
      const parcels = JSON.parse(JSON.stringify(req.data.data.parcels))
      const parcel_multi = parcels.filter(parcel => parcel.multiorder_count == 1)
      const parcels_list = parcel_multi.map(p => {
        const n_bultos = parcels.filter(a => a.multiorder_code === p.multiorder_code, p)
        p['n_bultos'] = n_bultos.length
        p['status2'] = (p.status in this.$sh_status) ? this.$sh_status[p.status] : p.status
      return p
      }, parcels)
      
      if (parcels_list.length == 0) {
        console.log('no data');
        this.rows.push({
          'from': 'no encontrado',
        })
      } else {
        this.rows = parcels_list;
      }
    },
    // goTo(where) {
    //   this.$router.push(where)
    //   //this.getParcels()
    // },
    parcelInfo(params) {
      let routeData = this.$router.resolve('/history/parcel/' + params.row.from + '/' + params.row.id);
      window.open(routeData.href, '_blank');
    },
    searchParcel() {
      // console.log(this.search);
      this.searching = true
      this.rows = []
      hapiickApi().post('/v4/shipments/search', {
        admin_id: JSON.parse(localStorage.admin).id,
        search: this.search
      }, {
        headers: {
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.token
        }
      })
      .then(request => this.updateTable(request))
      .catch((err) => console.log('error getting parcels:', err))
    },
    formatAmount: function(value) {
      return (value == null) ? '' : value + ' €';
    },
    formatStatus: (status) => {
      if (status === 'in-apt') {
        return 'en el armario'
      } else if (status === 'delivered') {
        return 'entregado'
      } else if (status === 'to-term') {
        return 'retirado por tienda'
      } else {
        return status
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Shophapiick/shParcelList.vue